let retryHandler = null;

export const setRetryHandler = (handler) => {
  retryHandler = handler;
};

export const retryCurrentPage = () => {
  if (retryHandler) {
    retryHandler();
  } else {
    console.warn("No retry handler registered");
  }
};
